module.exports = __webpack_public_path__ + "img/restore.eab38518.svg";